import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

import { dbKey } from "../../../model/Common";
import useStyles from "../useStyles";

/**
 * PressManagementTableHeadコンポーネント.
 *
 * @param {object} sortState ソート状態
 * @param {function} onClick ヘッダー押下時の処理
 * @return {object} コンポーネント
 */
function PressManagementTableHead(props) {
  // 引数
  const { sortState, onClick } = props;

  // スタイル
  const styles = useStyles();

  return (
    <TableHead>
      <TableRow>
        <TableCell
          className={`${styles.tableHeader} ${styles.machineNameTableCell}`}
          sortDirection={
            sortState.key === dbKey.pressNo ? sortState.type : false
          }
        >
          <TableSortLabel
            active={sortState.key === dbKey.pressNo}
            direction={sortState.type}
            onClick={() => onClick(dbKey.pressNo)}
          >
            工番
          </TableSortLabel>
        </TableCell>
        <TableCell
          className={`${styles.tableHeader} ${styles.machineNameTableCell}`}
          sortDirection={sortState.key === dbKey.label ? sortState.type : false}
        >
          <TableSortLabel
            active={sortState.key === dbKey.label}
            direction={sortState.type}
            onClick={() => onClick(dbKey.label)}
          >
            拠点名
          </TableSortLabel>
        </TableCell>
        <TableCell
          className={`${styles.tableHeader} ${styles.machineTableCell}`}
          sortDirection={
            sortState.key === dbKey.pressType ? sortState.type : false
          }
        >
          <TableSortLabel
            active={sortState.key === dbKey.pressType}
            direction={sortState.type}
            onClick={() => onClick(dbKey.pressType)}
          >
            プレス種別
          </TableSortLabel>
        </TableCell>
        <TableCell
          className={`${styles.tableHeader} ${styles.machineTableCell}`}
          sortDirection={
            sortState.key === dbKey.uploadCurve ? sortState.type : false
          }
        >
          <TableSortLabel
            active={sortState.key === dbKey.uploadCurve}
            direction={sortState.type}
            onClick={() => onClick(dbKey.uploadCurve)}
          >
            グラフ線図登録状況
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

PressManagementTableHead.propTypes = {
  sortState: PropTypes.shape({
    key: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PressManagementTableHead;
